import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { changeBillingStatus } from 'feature/billing/billingSlice';
import {
	downloadClaimsThunk,
	getClaimsByProviderThunk,
} from 'feature/claims/claimsThunk';

import { IState } from 'types/tableSelectedItems';

const initialState: IState = {
	selectedItems: [],
	downloadAll: false,
};

export const getClaims = createAsyncThunk(
	'claims/getClaims',
	getClaimsByProviderThunk,
);

export const downloadClaims = createAsyncThunk(
	'claims/downloadClaims',
	downloadClaimsThunk,
);

const tableSelectedItems = createSlice({
	name: 'tableSelectedItems',
	initialState,
	reducers: {
		setSelectOne: (state, { payload }: PayloadAction<string | number>) => {
			if (state.selectedItems.find(id => id === payload)) {
				const list = state.selectedItems.filter(id => id !== payload);
				state.selectedItems = list;
			} else {
				state.selectedItems.push(payload);
			}
		},
		setDownloadAll: (state: IState, { payload }: PayloadAction<boolean>) => {
			state.downloadAll = payload;
			state.selectedItems = [];
		},
		resetTableSelection: () => {
			return initialState;
		},
	},
	extraReducers: builder => {
		builder.addCase(changeBillingStatus.fulfilled, state => {
			state.selectedItems = [];
		});
	},
});

export const { setDownloadAll, setSelectOne, resetTableSelection } =
	tableSelectedItems.actions;
export default tableSelectedItems.reducer;
